/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Cta_LedeInputs */

const en_svc_research_cta_lede = /** @type {(inputs: Svc_Research_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One recent example is enough. We will tell you honestly whether an agent can answer it well.`)
};

const lv_svc_research_cta_lede = /** @type {(inputs: Svc_Research_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pietiek ar vienu nesenu piemēru. Godīgi pateiksim, vai aģents uz to var labi atbildēt.`)
};

/**
* | output |
* | --- |
* | "One recent example is enough. We will tell you honestly whether an agent can answer it well." |
*
* @param {Svc_Research_Cta_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_cta_lede = /** @type {((inputs?: Svc_Research_Cta_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Cta_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_cta_lede(inputs)
	return en_svc_research_cta_lede(inputs)
});